import { ButtonColor, ButtonSize, ButtonWithOptions, Spinner } from "@swivl-mono/ui";
import { useEffect } from "react";
import { BlankState, MenuOption, TitleForMenuOption } from "../BotAnalyticsDashboard";
import { ReviewDataForType, calculateReviewTotals } from "../Helpers/ReviewDataHelpers";

export const UpdatedReviews = ({ reviewData, updatedReviewMenu, renderTotalsAndChart, onMenuChange, loadReviewData }) => {
    // Load review data on component mount if not already loaded
    useEffect(() => {
        if (!reviewData) {
            loadReviewData();
        }
    }, [reviewData, loadReviewData]);

    let content;
    if (reviewData && reviewData.updatedByDateTime) {
        if (Object.keys(reviewData.updatedByDateTime).length === 0) {
            content = <div className="loadingContent">{BlankState()}</div>;
        } else {
            const data = ReviewDataForType(reviewData, updatedReviewMenu || MenuOption.Day, true);
            const totals = calculateReviewTotals(reviewData, true);
            content = renderTotalsAndChart(
                totals.total.toLocaleString(),
                totals.positive,
                totals.negative,
                "TOTAL",
                "POSITIVE",
                "NEGATIVE",
                ["#F67902", "#FFA900"],
                updatedReviewMenu === MenuOption.TimeOfDay,
                data,
            );
        }
    } else {
        content = (
            <div className="loadingContent">
                <Spinner />
            </div>
        );
    }

    return (
        <div className="chartBox">
            <div className="chartHeader">
                <div className="chartHeaderTitle">
                    <span>Updated Reviews by </span>
                    <ButtonWithOptions
                        color={ButtonColor.WHITE}
                        size={ButtonSize.SMALL}
                        buttonOptions={[
                            { title: "Day", name: "Day", onClick: () => onMenuChange("updatedReviewMenu", "Day") },
                            { title: "Time of Day", name: "TimeOfDay", onClick: () => onMenuChange("updatedReviewMenu", "TimeOfDay") },
                            { title: "Day of Week", name: "DayOfWeek", onClick: () => onMenuChange("updatedReviewMenu", "DayOfWeek") },
                        ]}
                    >
                        {TitleForMenuOption(updatedReviewMenu || MenuOption.Day)}
                    </ButtonWithOptions>
                </div>
                <div className="spacer" />
                <div className="chartKey">
                    <div className="chartKeyItem">
                        <span className="chartKeyBox" style={{ background: "#F67902" }} />
                        Positive
                    </div>
                    <div className="chartKeyItem">
                        <span className="chartKeyBox" style={{ background: "#FFA900" }} />
                        Negative
                    </div>
                </div>
            </div>
            <div className="chartContent">{content}</div>
        </div>
    );
};
